import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { of } from 'rxjs';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import { MyProfileService } from '@/features/my/services/my-profile.service';
import { CurrentUserService } from '@/services/current-user.service'; // Adjust the path as needed
import * as TeamsActions from './teams.actions';
import { loadUserProfile, loadUserProfileSuccess, loadUserProfileFailure, updateUserProfile, updateUserProfileSuccess, updateUserProfileFailure } from './profile.actions';

@Injectable()
export class CurrentUserEffects {
  private actions$ = inject(Actions);
  constructor(
    private myProfileService: MyProfileService,
    private currentUserService: CurrentUserService,
    private oidcSecurityService: OidcSecurityService
  ) {}

  loadUserProfile$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadUserProfile),
      switchMap(() =>
        // Retrieve the token from OidcSecurityService
        this.oidcSecurityService.getAccessToken().pipe(
          mergeMap((token) =>
            this.myProfileService.getUserProfile(token).pipe(
              map((currentUser) => loadUserProfileSuccess({ currentUser })),
              catchError((error) => of(loadUserProfileFailure({ error })))
            )
          )
        )
      )
    )
  );

  updateUserProfile$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateUserProfile),
      mergeMap((action) =>
        this.myProfileService.updateUserProfile(action.currentUser).pipe(
          map(() => updateUserProfileSuccess()),
          catchError((error) => of(updateUserProfileFailure({ error })))
        )
      )
    )
  );

  // Reload user profile after successful update to refresh the store
  reloadUserProfileAfterUpdate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateUserProfileSuccess),
      switchMap(() =>
        this.oidcSecurityService.getAccessToken().pipe(
          mergeMap((token) =>
            this.myProfileService.getUserProfile(token).pipe(
              map((currentUser) => loadUserProfileSuccess({ currentUser })),
              catchError((error) => of(loadUserProfileFailure({ error })))
            )
          )
        )
      )
    )
  );

  loadCurrentUserTeams$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TeamsActions.loadCurrentUserTeams),
      mergeMap(() =>
        this.currentUserService.getUserTeams().pipe(
          map((teams) => TeamsActions.loadCurrentUserTeamsSuccess({ teams })),
          catchError((error) => of(TeamsActions.loadCurrentUserTeamsFailure({ error })))
        )
      )
    )
  );
}
